import { useState } from "react";
import "../CSS/update-balance.css";

const UpdateBalanceModal = ({
  title,
  handleSubmit,
  initialAmount,
  onClose,
  loading,
}) => {
  const [amount, setAmount] = useState(initialAmount);

  return (
    <form
      className="bv-update-balance-modal"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(amount);
      }}
    >
      <header>
        <h4>{title}</h4>
      </header>

      <div className="body">
        <div className="form-group">
          <label className="form-label" htmlFor="amount">
            Amount
          </label>

          <input
            type="number"
            className="form-control"
            value={amount}
            onChange={(e) => setAmount(e.target.valueAsNumber)}
            min={0}
            required
          />
        </div>
      </div>

      <div className="actions">
        <button type="submit" className="update">
          {loading ? "..." : "Update"}
        </button>

        <button type="button" onClick={onClose}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default UpdateBalanceModal;
